// @mui
import { styled } from '@mui/material/styles'
import { Card, Container, Typography, Box } from '@mui/material'
import Logo from '../../components/icons/Logo'
import useResponsive from '../../hooks/useResponsive'
import LoginForm from '../../components/domains/auth/LoginForm'
import { useTranslate } from 'react-admin'
import LogoFrame from '../../components/icons/LogoFrame'

const RootStyle = styled('div')(({ theme }) => ({
  [theme.breakpoints.up('md')]: {
    display: 'flex',
  },
}))

const HeaderStyle = styled('header')(({ theme }) => ({
  top: 0,
  zIndex: 9,
  lineHeight: 0,
  width: '100%',
  maxWidth: 480,
  left: '50%',
  transform: 'translateX(-50%)',
  display: 'flex',
  alignItems: 'center',
  position: 'absolute',
  paddingTop: theme.spacing(3),
  paddingLeft: theme.spacing(2),
  paddingRight: theme.spacing(2),
  justifyContent: 'space-between',
  [theme.breakpoints.up('sm')]: {
    paddingLeft: theme.spacing(0),
    paddingRight: theme.spacing(0),
  },
  [theme.breakpoints.up('md')]: {
    maxWidth: 'unset',
    left: '50%',
    alignItems: 'flex-start',
    padding: theme.spacing(7, 5, 0, 7),
  },
}))

const SectionStyle = styled(Card)(({ theme }) => ({
  background: `linear-gradient(180deg, ${theme.palette.primary.dark} 0%, ${theme.palette.primary.light} 100%)`,
  width: '100%',
  maxWidth: 464,
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  padding: theme.spacing(2, 2, 2, 2),
  borderRadius: 0,
}))

const ContentStyle = styled('div')(({ theme }) => ({
  maxWidth: 480,
  margin: 'auto',
  minHeight: '100vh',
  display: 'flex',
  justifyContent: 'center',
  flexDirection: 'column',
  [theme.breakpoints.up('md')]: {
    padding: theme.spacing(12, 0),
  },
}))

export default function Login(): JSX.Element {
  const translate = useTranslate()
  const mdUp = useResponsive('up', 'md', 0, 0)
  const mdDown = useResponsive('down', 'md', 0, 0)
  return (
    <Box title='Login'>
      <RootStyle>
        <HeaderStyle>
          {mdDown && (
            <LogoFrame
              sx={{
                pt: '15px',
                width: 80,
                height: 80,
              }}
            />
          )}
        </HeaderStyle>
        {mdUp && (
          <SectionStyle>
            <Logo
              sx={{
                width: 250,
                height: 'auto',
                fill: 'none',
                margin: 'auto',
                display: 'block',
              }}
            />
          </SectionStyle>
        )}
        <Container maxWidth='sm'>
          <ContentStyle>
            <Typography variant='h4' gutterBottom>
              {translate('ra.message.login_title')}
            </Typography>

            <Typography sx={{ color: 'text.secondary', mb: 5 }}>
              {/* {translate('ra.message.login_sub_title')} */}
            </Typography>
            <LoginForm />
          </ContentStyle>
        </Container>
      </RootStyle>
    </Box>
  )
}
